import React from 'react';

import { PageIntroWrapper } from './styled';
import win from '../../../../r/shared/win';
import Button from '../button';

const { isLoggedIn } = win;

const PageIntro = () => (
  <PageIntroWrapper>
    <h1>Form building software that always works, everytime</h1>
    <p>
      Whether you’re trying to create online forms with advanced branching, or collaborate with your team, do it easily with a robust form building platform that supports your favourite work tools.
    </p>
    <Button
      href={!isLoggedIn ? '/auth?utm_source=website&utm_medium=features-page' : '/r'}
      text={!isLoggedIn ? 'Try it for Free' : 'Dashboard'}
      className="success shadow"
      size="large"
    />
  </PageIntroWrapper>
);

export default PageIntro;